
export default class PlayBackManager{

    constructor(){
        this.mediaQueryLists = [];
        this.mediaQueries = [];
        this.mediaQueryPause = false;
        this.lastEvent = null;
        this.EVENT = {};

        this.isRock = false;
        this._onBlur = this._onBlur.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onVisibilityChange = this._onVisibilityChange.bind(this);
        this._mediaQueryListener = this._mediaQueryListener.bind(this);

        this._init();
    }
    

    pause(){
        window.dispatchEvent(new CustomEvent(this.EVENT.PAGE_PAUSE));
    }


    resume(){
        window.dispatchEvent(new CustomEvent(this.EVENT.PAGE_RESUME));
    }


    set _isRock(val){
        this.isRock = val;
    }

    get _isRock(){
        return this.isRock;
    }




    _init(){
        this.EVENT.PAGE_PAUSE = 'page_pause';
        this.EVENT.PAGE_RESUME = 'page_resume';

        this.mediaQueries = [
            'print, screen and (min-width: 1280px)',
            'print, screen and (max-width: 1279px) and (min-width: 1001px) and (orientation: landscape)',
            'print, screen and (max-width: 1000px) and (orientation: landscape)',
        ];

        for(const query of this.mediaQueries){
            const mql = window.matchMedia(query);
            mql.addEventListener('change', this._mediaQueryListener);
            this.mediaQueryLists.push(mql);
        }

        window.addEventListener('blur', this._onBlur);
        window.addEventListener('focus', this._onFocus);
        document.addEventListener('visibilitychange', this._onVisibilityChange);
    }


    _onBlur() {
        if(this.isRock) return;

        this.lastEvent = 'blur';
        this.pause();
    }


    _onFocus() {
        if(this.isRock) return;

        this.lastEvent = 'focus';
        if(!this.mediaQueryPause) this.resume();
    }


    _onVisibilityChange() {
        if(this.isRock) return;

        if(document.hidden){
            if(this.lastEvent !== 'blur') this.pause();
        }
        else{
            if(this.lastEvent !== 'focus' && !this.mediaQueryPause) this.resume();
        }

        this.lastEvent = null;
    }


    _mediaQueryListener() {
        if(this.isRock) return;
        if(!document.hasFocus()) return;

        const isMatched = this.mediaQueryLists.some(mql => mql.matches);
        if(!isMatched){
            this.mediaQueryPause = true;
            this.pause();
        }
        else{
            this.mediaQueryPause = false;
            this.resume();
        }
    }
}